import type { SYSFormField } from "../../../../../../../_ovlclient/src/library/forms/fieldapi"
import type { SYSTableDef } from "../../../../../../../_ovlclient/src/library/table/tableapi"

export let searchPaketFields: { [key: string]: SYSFormField } = {
  Search: {
    list: {
      displayField: "U_PartId",
      valueField: "U_PartId",
      displayValueField: true,
      acceptOnlyListValues: true,
    },
    ui: { labelTranslationKey: "SPKSearchPaketSearchPaketSearch" },
  },
}

export let searchPaket = {
  search: "",
  selectedOrder: "",
}

export let tblSearchPaket: SYSTableDef = {
  id: "DATSearchPaket",
  feature: "DATSearchPaket",
  database: {
    dataIdField: "Code",
    dbInsertMode: "Manual",
  },
  server: {
    endpoint: "searchpaket",
  },
  features: {
    headerMenu: true,
    stickyHeader: false,
  },
  options: {
    initial_paging: { page: 0, pageSize: 10000 },
    initial_sort: {
      field: "U_Profile",
      direction: "asc",
      directionMobile: "asc",
      fieldMobile: "U_PartId",
    },
  },

  columns: {
    MobileDesc: {
      sortable: true,
      ui: {
        visibility: "TableOnlyMobile",
        labelTranslationKey: "SPKSearchPaketSearchPaketColMobileDesc",
      },
    },
    U_Profile: {
      sortable: true,
      ui: {
        visibility: "TableNotMobile_Edit_View",
        labelTranslationKey: "SPKSearchPaketSearchPaketColDescription",
      },
      filter: { columnFilter: { type: "none" } },
    },
    U_PartId: {
      sortable: true,
      ui: {
        visibility: "TableNotMobile_Edit_View",
        labelTranslationKey: "SPKSearchPaketSearchPaketColPartId",
      },
    },
    U_ReqQuantity: {
      sortable: true,
      ui: {
        visibility: "TableNotMobile_Edit_View",
        labelTranslationKey: "SPKSearchPaketSearchPaketColReqQuantity",
      },
    },
    U_Width: {
      sortable: true,
      ui: {
        visibility: "TableNotMobile_Edit_View",
        labelTranslationKey: "SPKSearchPaketSearchPaketColWidth",
        format: "0digits",
      },
    },
    U_Height: {
      sortable: true,
      ui: {
        visibility: "TableNotMobile_Edit_View",
        labelTranslationKey: "SPKSearchPaketSearchPaketColHeight",
        format: "0digits",
      },
    },
    U_Length: {
      sortable: true,
      ui: {
        visibility: "TableNotMobile_Edit_View",
        labelTranslationKey: "SPKSearchPaketSearchPaketColLength",
        format: "0digits",
      },
    },
    U_SK: {
      sortable: true,
      ui: {
        visibility: "TableNotMobile_Edit_View",
        labelTranslationKey: "SPKSearchPaketSearchPaketColSK",
      },
      filter: { columnFilter: { type: "none" } },
    },
    U_Unit: {
      sortable: true,
      ui: {
        labelTranslationKey: "SPKSearchPaketSearchPaketColUnit",
      },
    },
  },
}
